// 用餐模块的请求
import axios from 'axios'
import {
	MessageBox,
	Message
} from 'element-ui'
import store from '@/store'
import {
	get
} from 'lodash'

const url = 'https://oa.yunqingtech.com:443';
//const url = 'http://192.168.4.97:9191';
// 创建axios实例
const service = axios.create({
	baseURL: url, // url = base url + request url
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	timeout: 120000, // request timeout
})

// request拦截器
service.interceptors.request.use(
	config => {
		//如果存在token，请求携带这个token
		if (window.sessionStorage.getItem('userIdStr')) {
			config.headers['userIdStr'] = '#ATMyMDO##wN3gzM4QTNyMDOxYTM';
		    config.headers['userName'] = 'admin';

		}
		// config.headers['Priority-value'] = 'xm';
		return config;

	},
	error => {
		// do something with request error
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * 如果您想获得http信息，如标头或状态
	 * 请返回response => response
	 */


	response => {
		const res = response.data

		if (res.code !== 200) {
			Message({
				message: res.msg || 'Error',
				type: 'error',
				duration: 5 * 1000
			})
			if (res.code === 500 || res.code === 512 || res.code === 504 || res.code === 401 || res.code === 201) {}
			return res || 'Error'
		} else {
			return res
		}
	},
	error => {

		return error.response.data
	}
)

export default service